import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { toast } from 'react-toastify';
import MemberMembershipService from '../../../../../../services/member_membership_service';
import ConfirmDialog from '../../../../../../components/Common/ConfirmDialog';
import { NeoButton, NeoInput } from '../../../../../../components/Common';

import { toISODate, formatDate } from "../../../../../../utils/date";

const ActionAddDays = ({ activeAction, membership, idTenant, user, onRefresh }) => {
    const [daysCount, setDaysCount] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    const isAdd = activeAction === "addDays";
    const actionName = isAdd ? "Adicionar" : "Remover";
    const iconClass = isAdd ? "mdi-calendar-plus" : "mdi-calendar-minus";

    const handleApply = async () => {
        const n = parseInt(daysCount, 10);
        if (!n || n <= 0) return toast.warning("Informe um número de dias válido.");
        
        if (!isAdd) {
            const ok = await ConfirmDialog({
                title: "Confirmar Redução?",
                text: `Esta ação antecipará o vencimento. Tem certeza que deseja remover ${n} dia(s)?`,
                confirmButtonText: "Sim, confirmar",
            });
            if (!ok) return;
        }

        setLoading(true);
        try {
            const d = new Date(membership.endDate + "T23:59:59");
            d.setDate(d.getDate() + (isAdd ? n : -n));
            
            await MemberMembershipService.update(membership.id, idTenant, user, {
                endDate: toISODate(d),
                updatedReason: reason || (isAdd ? "Adição manual de dias" : "Remoção manual de dias")
            });
            
            toast.success(`Ajuste concluído: ${n} dia(s) ${isAdd ? 'adicionado(s)' : 'removido(s)'}.`);
            setDaysCount("");
            setReason("");
            if (onRefresh) onRefresh();
        } catch (error) { 
            toast.error(`Erro ao ${actionName.toLowerCase()} dias.`);
            console.error(error);
        } finally { 
            setLoading(false); 
        }
    };

    const currentEndDateStr = formatDate(membership.endDate);
    let newEndDateStr = "---";

    if (daysCount && !isNaN(daysCount) && daysCount > 0) {
        const dt = new Date(membership.endDate + "T00:00:00");
        dt.setDate(dt.getDate() + (isAdd ? +daysCount : -daysCount));
        newEndDateStr = formatDate(toISODate(dt));
    }

    return (
        <div className="p-4 border mt-3 bg-white shadow-sm" style={{ borderRadius: '12px', borderColor: 'rgba(0, 0, 0, 0.06)', fontFamily: 'Outfit, sans-serif' }}>
            <div className="d-flex align-items-center mb-3">
                <i className={`mdi ${iconClass} fs-4 me-2 text-muted`} style={{ color: 'var(--color-brand-secondary) !important' }}></i>
                <h6 className="fw-bold mb-0 text-uppercase" style={{ letterSpacing: "0.5px", color: 'var(--color-brand-primary)', fontFamily: 'Outfit, sans-serif' }}>
                    {isAdd ? "Adicionar Dias ao Contrato" : "Reduzir Dias do Contrato"}
                </h6>
            </div>
            
            <p className="text-muted font-size-13 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {isAdd 
                    ? "Utilize esta função para conceder cortesias, dias compensatórios ou tratar exceções administrativas. O vencimento será estendido."
                    : "Utilize esta função para encurtar a validade do contrato devido a pendências, recálculos ou acordos firmados com o aluno."}
            </p>

            <Row className="g-3 align-items-start" style={{ fontFamily: 'Outfit, sans-serif' }}>
                <Col md={3}>
                    <NeoInput
                        label="Quantidade (Dias)"
                        type="number"
                        min="1"
                        placeholder="Ex: 5"
                        value={daysCount}
                        onChange={e => setDaysCount(e.target.value)}
                        size="sm"
                    />
                </Col>
                <Col md={6}>
                    <NeoInput
                        label="Motivo (Para auditoria)"
                        placeholder="Descreva a razão do ajuste..."
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                        size="sm"
                    />
                </Col>
                <Col md={3} className="d-flex align-items-end" style={{ height: "62px" }}>
                    <NeoButton
                        variant="primary"
                        onClick={handleApply}
                        loading={loading}
                        disabled={!daysCount || daysCount <= 0}
                        size="sm"
                        className="w-100 mb-0"
                        style={{ height: "36px" }}
                    >
                        Confirmar
                    </NeoButton>
                </Col>
            </Row>

            {daysCount > 0 && (
                <div className="mt-4 pt-3 border-top" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                    <div className="font-size-11 text-muted text-uppercase mb-2 fw-bold" style={{ letterSpacing: "0.5px" }}>
                        Impacto no Vencimento do Plano
                    </div>
                    <div className="d-flex align-items-center p-3 rounded-3 border bg-white shadow-sm" style={{ borderColor: 'rgba(72, 39, 18, 0.08)' }}>
                        <div className="flex-grow-1 text-center">
                            <div className="text-muted font-size-11 text-uppercase mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Data Atual</div>
                            <div className="fw-bold font-size-15 text-dark" style={{ fontFamily: 'Outfit, sans-serif' }}>{currentEndDateStr}</div>
                        </div>
                        <div className="px-3 text-muted">
                            <i className="mdi mdi-arrow-right fs-4"></i>
                        </div>
                        <div className="flex-grow-1 text-center">
                            <div className="text-muted font-size-11 text-uppercase mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Data Ajustada</div>
                            <div className="fw-bold font-size-15" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--color-brand-accent)' }}>{newEndDateStr}</div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionAddDays;
